import { cn } from '@nexelem/utils';
import { MouseEvent, PropsWithChildren } from 'react';

export type PopperMenuContainerProps = {
  className?: string;
  onClose?: () => void;
};

export const PopperMenuContainer = ({ children, className, onClose }: PropsWithChildren<PopperMenuContainerProps>) => {
  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    const isActionableElement = target.closest('button, a');

    if (isActionableElement && onClose) {
      onClose();
    }
  };

  return (
    <div
      className={cn(
        'flex flex-col items-stretch justify-stretch rounded-xs bg-surface-primary [&_a]:justify-start [&_a]:rounded-none [&_button]:justify-start [&_button]:rounded-none',
        className,
      )}
      onClick={handleClick}
    >
      {children}
    </div>
  );
};
